const PREFIX = 'LAYOUT';
export default {
    LOAD_CONNECT_PARAMS: `${PREFIX}:LOAD_CONNECT_PARAMS`,
    LOAD_GA_TRACKER: `${PREFIX}:LOAD_GA_TRACKER`
};


// WEBPACK FOOTER //
// ./src/modules/configuration/actionTypes.js